import React from 'react';
import PropTypes from 'prop-types';
import { Buttons } from 'lidya-common-components';

import { GetExternalLinkButton } from '../../../common/externalLinks/external.link.button';
import { useGlobalData } from '../../../../providers/globalDataProvider/globalDataProvider.useGlobalData';

const COMMUNICATION_URL = `${process.env.GATSBY_COMMUNICATION_URL}`;

export function GetLoanNowButton({ id, type, className }) {
  const { country } = useGlobalData();
  const href = `${COMMUNICATION_URL}/instant-loan?country=${country}`;
  return (
    <GetExternalLinkButton
      type={type}
      className={className}
      href={href}
      id={`InstantLoanButton${country}${id}`}
      label="web.header.support.button.loan"
      target="_self"
    />
  );
}

GetLoanNowButton.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
};

GetLoanNowButton.defaultProps = {
  type: Buttons.BUTTON_TYPES.SECONDARY,
  className: undefined,
  id: '',
};

export default GetLoanNowButton;
